import { render, staticRenderFns } from "./ClosingsChips.vue?vue&type=template&id=50e4e4d8"
import script from "./ClosingsChips.vue?vue&type=script&lang=js"
export * from "./ClosingsChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports